import { isNil } from "lodash";

export const defaultMessages = {
  success: null,
  error: null,
  warning: null,
};

export const defaultSearch = {
  timeframe: null,
  licenseKey: ''
};

export const defaultPagination = {
  current: 1,
  pageLimit: 10,
  currentLength: 0
};

export const defaultColumns = (isOrg) => {
  const list = [
    {
      label: '5d5c4ad5db',
      accessor: 'licenseKey',
      sortable: true,
      sortbyOrder: 'asc',
    },
    {
      label: 'cf5f3091e3',
      accessor: 'termDays',
      sortable: true,
      downloadName: 'termUnitLabelFull',
    },

    {
      label: '8a6ce18ee4',
      accessor: 'releasedAtUnix',
      sortable: true,
      downloadName: 'releasedAtFormat',
    },
    // msp
    {
      label: 'c1ca926603',
      accessor: 'organizationName',
      sortable: true,
      hide: isOrg,
    },
    {
      label: 'c9772a79fb',
      accessor: 'orgUid',
      sortable: true,
      hide: isOrg,
    },
    // msp

    {
      label: '402d4d2bce',
      accessor: 'deviceModelName',
      sortable: true,
    }
  ];
  const result = (list).filter((item, index) => {
    return isNil(item.hide) || !item.hide;
  });
  return result;
};

